// NAUMAN IT SOLUTIONS — theme behaviour

(function () {
  var settings = window.themeSettings || {};
  var WHATSAPP_NUMBER = settings.whatsappInternational || "923210839995";
  var DEFAULT_WA_MESSAGE =
    settings.whatsappDefaultMessage ||
    "Hello NAUMAN IT SOLUTIONS, I am interested in your website development services. I would like to discuss my project.";

  function buildWhatsAppLink(message) {
    var text = encodeURIComponent(message || DEFAULT_WA_MESSAGE);
    return "https://wa.me/" + WHATSAPP_NUMBER + "?text=" + text;
  }

  // Wire up every WhatsApp CTA on the page (identified by the data-wa attribute)
  document.querySelectorAll("[data-wa]").forEach(function (el) {
    var customMsg = el.getAttribute("data-wa-message");
    el.setAttribute("href", buildWhatsAppLink(customMsg));
    el.setAttribute("target", "_blank");
    el.setAttribute("rel", "noopener");
  });

  // Mobile nav toggle
  var toggle = document.querySelector("[data-nav-toggle]");
  var mobileMenu = document.querySelector("[data-mobile-menu]");
  if (toggle && mobileMenu) {
    toggle.addEventListener("click", function () {
      var isOpen = mobileMenu.classList.toggle("open");
      toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
      document.body.style.overflow = isOpen ? "hidden" : "";
    });
    mobileMenu.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", function () {
        mobileMenu.classList.remove("open");
        document.body.style.overflow = "";
      });
    });
  }

  // Scroll-reveal for elements marked .reveal
  var revealEls = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window && revealEls.length) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -40px 0px" }
    );
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add("in"); });
  }

  // Portfolio filter (portfolio page only)
  var tagButtons = document.querySelectorAll(".tag[data-filter]");
  var portfolioItems = document.querySelectorAll("[data-category]");
  if (tagButtons.length && portfolioItems.length) {
    tagButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        tagButtons.forEach(function (b) { b.classList.remove("is-on"); });
        btn.classList.add("is-on");
        var filter = btn.getAttribute("data-filter");
        portfolioItems.forEach(function (item) {
          var match = filter === "all" || item.getAttribute("data-category") === filter;
          item.style.display = match ? "" : "none";
        });
      });
    });
  }

  // ---------- Contact form: validation, honeypot, duplicate-submit guard ----------
  var contactForm = document.getElementById("ContactForm");
  if (contactForm) {
    var submitBtn = contactForm.querySelector('button[type="submit"]');
    var originalLabel = submitBtn ? submitBtn.textContent : "Submit";
    var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    function setFieldState(field, message) {
      if (!field) return;
      var wrapper = field.closest(".field");
      var errorEl = wrapper ? wrapper.querySelector(".field-error") : null;
      if (message) {
        if (wrapper) wrapper.classList.add("has-error");
        field.setAttribute("aria-invalid", "true");
        if (errorEl) errorEl.textContent = message;
      } else {
        if (wrapper) wrapper.classList.remove("has-error");
        field.setAttribute("aria-invalid", "false");
        if (errorEl) errorEl.textContent = "";
      }
    }

    function validateField(field) {
      if (!field) return true;
      var name = field.getAttribute("name");
      var value = field.value.trim();

      if (name === "contact[Name]") {
        if (value.length < 2) { setFieldState(field, "Please enter your full name."); return false; }
      }
      if (name === "contact[email]") {
        if (!EMAIL_PATTERN.test(value)) { setFieldState(field, "Please enter a valid email address."); return false; }
      }
      if (name === "contact[Phone]" && value.length > 0) {
        var digits = value.replace(/[^0-9]/g, "");
        if (digits.length < 7) { setFieldState(field, "Please enter a valid phone number."); return false; }
      }
      if (name === "contact[body]") {
        if (value.length < 10) { setFieldState(field, "Please tell us a little about your project."); return false; }
      }

      setFieldState(field, null);
      return true;
    }

    var validatedFields = ["contact[Name]", "contact[email]", "contact[Phone]", "contact[body]"]
      .map(function (name) { return contactForm.querySelector('[name="' + name + '"]'); })
      .filter(Boolean);

    validatedFields.forEach(function (field) {
      field.addEventListener("blur", function () { validateField(field); });
      field.addEventListener("input", function () {
        if (field.closest(".field.has-error")) validateField(field);
      });
    });

    contactForm.addEventListener("submit", function (e) {
      // Block duplicate submissions if already sending
      if (contactForm.dataset.submitting === "true") {
        e.preventDefault();
        return;
      }

      // Honeypot: if this hidden field has a value, it's almost certainly a bot.
      var honeypot = contactForm.querySelector('[name="contact[website]"]');
      if (honeypot && honeypot.value.trim().length > 0) {
        e.preventDefault();
        return;
      }

      var allValid = true;
      var firstInvalid = null;
      validatedFields.forEach(function (field) {
        var ok = validateField(field);
        if (!ok) {
          allValid = false;
          if (!firstInvalid) firstInvalid = field;
        }
      });

      if (!allValid) {
        e.preventDefault();
        if (firstInvalid) firstInvalid.focus();
        return;
      }

      // Valid submission: lock the button so a double-click can't send it twice.
      contactForm.dataset.submitting = "true";
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = "Sending\u2026";
      }
    });
  }

  // Move focus to the success/error banner so screen reader users notice it
  var formBanner = document.getElementById("ContactFormSuccess");
  if (formBanner) {
    formBanner.focus();
  }
})();
